import { Location } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { ContentService } from 'src/app/core/services/content.service';
import { PlayContentService } from 'src/app/core/services/play-content.service';
import { SearchService } from 'src/app/core/services/search.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-ai-search',
  standalone: true,
  imports: [ReactiveFormsModule, HttpClientModule],
  templateUrl: './ai-search.component.html',
  styleUrl: './ai-search.component.scss'
})
export class AiSearchComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild('scrollContainer') private scrollContainer: ElementRef;
  chatForm:FormGroup
  chatArray = [];
  aiChatDefaultDatas=[];
  enableTrailer;
  showLoader = false;
  audioSupport = false;
  enableProfiles = false;
  profileInfo: any;
  imagePath;
  guest;
  userName;
  constructor(public settingsService:SettingsService, private fb: FormBuilder, public http:HttpClient, public storageService:StorageService,
    public searchService:SearchService, public configService:ConfigurationService, public playContentService:PlayContentService, 
    public location: Location, public baseService: BaseService, public contentService:ContentService, private router: Router, 
    public loggerService: LoggerService, public subscriptionService:SubscriptionService ){
    this.imagePath = this.settingsService.imagePath;
    if(this.settingsService.audioSupported) this.audioSupport = true;
    else this.audioSupport = false;
    this.enableTrailer = this.settingsService.enableTrailers;
    if (this.settingsService?.maxUserProfiles > 0) this.enableProfiles = true;
    else this.enableProfiles = false;
    if(this.settingsService.aiChatDefault || this.settingsService.aiChatDefault != ' ') this.aiChatDefaultDatas = this.settingsService.aiChatDefault.split(",")
    this.chatForm = this.fb.group({
      userMessage: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.baseService.loaderSource.next(false);
    this.settingsService.showAskAi.next(false);
    if(!this.storageService.getSessionStore('chat_u_id')) this.storageService.setSessionStore('chat_u_id', uuidv4());
    this.baseService.guest.subscribe(data => {
      this.guest = data
    });
    this.loggerService.profileInfo.subscribe(value => {
      this.profileInfo = value;
    });
    if(this.subscriptionService.userDetails.name) this.userName = this.subscriptionService.userDetails.name;
    this.settingsService.showFooter = false;
  }

  ngAfterViewChecked(): void {
  }

  sendData(data){
    let userMessage = data;
    let request = {
      request:userMessage
    }
    this.chatArray.push(request);
    this.scrollToBottom();
    this.searchDataCall(userMessage);
  }

  sendMessage() {
    if (this.chatForm.valid) {
      const userMessage = this.chatForm.get('userMessage')?.value;
      this.chatForm.reset();
      let request = {
        request:userMessage
      }
      this.chatArray.push(request);
      this.scrollToBottom();
      this.searchDataCall(userMessage);
    }
  }

  searchDataCall(userMessage){
    this.showLoader = true;
    this.searchService.getData(userMessage, 0, 12, 1).subscribe((data)=>{
      if(data){
        console.log(data);
        this.showLoader = false;
        let slicedData = data.contents[0].list.slice(0,12)
        let message = data.ai_message;
        let response = {
          response:slicedData,
          message:message
        }
        this.chatArray.push(response)
      }
    })
  }

  transform(data) {
    let min = data;
    if (min > 60) {
      let hours = Math.floor(min / 60);
      let minutes = min % 60;
      return `${hours} ${this.configService?.localeKeys?.["common_keys.hr_letter.text"] || 'h'} ${minutes} ${this.configService?.localeKeys?.["common_keys.min_letter.text"] || 'm'}`
    } else {
      return `${min} ${this.configService?.localeKeys?.["common_keys.min_letter.text"] || 'm'}`
    }
  }

  onEnter(event: KeyboardEvent) {
    event.preventDefault();
    this.sendMessage();
  }

  scrollToBottom(): void {
    setTimeout(() => {
      this.scrollContainer.nativeElement.scrollTo({
        top: this.scrollContainer.nativeElement.scrollHeight + 50,
        behavior: 'smooth'
      });
    });
  }

  contentRoute(video){
    if (video.is_livechannel) {
      this.baseService.storeEPGValue(video.slug);
      if(this.settingsService.epgEnabled)this.contentService.autoPlayVideo = true;
      const slug = video?.slug || video?.content_slug
      this.router.navigate(['/live', slug]);
    } else if (video.is_series) {
      const seriesSlug = video?.seasons_slug || video?.series_slug;
      const contentSlug = video?.content_slug;
      if (video.watched_duration) {
        this.contentService.contentSlug = contentSlug;
        this.contentService.seriesSlug = seriesSlug;
        this.contentService.seekValue = video.watched_duration;
      } else {
        this.contentService.seekValue = 0;
      }
      this.router.navigate(['/vs', seriesSlug]);
    } else {
      this.router.navigate(['/v', video.collection_slug, video.content_slug]);
    }
  }

  goBack() {
    this.settingsService.showAskAi.next(true);
    this.location.back();
  }

  ngOnDestroy(): void {
    this.settingsService.showFooter = true;
    this.settingsService.showAskAi.next(true);
  }

}
